export default {"src":"/_next/static/media/currency-exchange-icon.3effa6cc.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};